import { EventHandler } from "../../../util/event/EventHandler";
import { ObjectUtil } from "../../../util/object/ObjectUtil";
import { ResultCode, Constants } from "../../common/controller/net/constant/Constants";
import { OperatorData } from "../../common/controller/net/response/data/OperatorData";
import { SessionTimeOutEvent } from "../../common/controller/net/response/event/SessionTimeOutEvent";
import { CommonOperatorEvent } from "../../common/operator/CommonOperatorEvent";
import { AppCore } from "../AppCore";
import { DataObject } from "../data/DataObject";
import { HttpRequest } from "./HttpRequest";
import { RequestConstants } from "./RequestConstants";
/**
 * WebRequest.ts
 */
export class WebRequest {
    constructor(url, requestData = null) {
        this.core = AppCore.getInstance();
        this.requestData = requestData;
        this.url = this.getPrimaryNode() + url;
    }
    onSuccess(handler, scope) {
        this.successHandler = new EventHandler(handler, scope);
    }
    onFailure(handler, scope) {
        this.failureHandler = new EventHandler(handler, scope);
    }
    handleResponse(data = null) {
        this.handleWrapperObject(data);
        let responseData = this.createResponseData(data);
        if (responseData) {
            responseData.solidify();
        }
        let success = responseData && responseData.isSuccess();
        success ? this.successHandler.call(responseData) : this.failureHandler.call(responseData);
        this.handleSessionTimeOut(responseData);
        if (responseData.getResponseCode() == ResultCode.OPERATOR_ERROR) {
            this.handleOperatorError(data);
        }
    }
    handleOperatorError(data) {
        let errorData = new OperatorData(new DataObject(data));
        errorData.solidify();
        this.core.setOperatorData(errorData);
        this.core.dispatchEvent(CommonOperatorEvent.OPERATOR_DATA);
    }
    handleWrapperObject(data) {
        let wrapperObject = data["wrapperObject"];
        wrapperObject = wrapperObject ? wrapperObject : data["wrapper"]; // This is to enable fishing to work
        if (wrapperObject) {
            this.core.setWrapperObject(wrapperObject);
            this.core.dispatchEvent(CommonOperatorEvent.WRAPPER_OBJECT);
        }
    }
    createResponseData(data) {
        return ObjectUtil.create(this.getDataClass(), new DataObject(data));
    }
    send() {
        let method = this.getMethod();
        if (method == RequestConstants.POST) {
            this.sendRequest(this.url, this.createRequestData());
        }
        else if (method == RequestConstants.GET) {
            this.sendRequest(this.url + this.createRequestParams());
        }
        else if (method == RequestConstants.PUT) {
            this.sendRequest(this.url, this.createRequestData());
        }
    }
    createRequestData() {
        let liquidData = this.requestData ? this.requestData.liquify() : new DataObject();
        let accessToken = this.getToken();
        if (this.tokenize() && accessToken && this.getTokenMethod() == RequestConstants.BODY) {
            liquidData.putString(Constants.PROPERTY_TOKEN, accessToken);
        }
        return this.toJSON(liquidData.toObject());
    }
    createRequestParams() {
        let requestData = this.parseJSON(this.createRequestData());
        let requestParams = "";
        if (requestData) {
            for (let property in requestData) {
                requestParams += property + "=" + requestData[property] + "&";
            }
            if (requestParams.length > 0) {
                requestParams = "?" + requestParams.substring(0, requestParams.length - 1);
            }
        }
        return requestParams;
    }
    sendRequest(url, data) {
        this.request = new HttpRequest(this.getMethod(), url);
        this.request.setContentType(this.getContentType());
        this.request.setResponseType(this.getResponseType());
        this.request.setAsync(this.getAsync());
        if (this.getTokenMethod() == RequestConstants.HEADER) {
            this.request.setToken(this.getToken());
        }
        this.request.onComplete(this.handleRequestComplete, this);
        this.request.onError(this.handleRequestError, this);
        this.request.send(data);
    }
    getToken() {
        let model = this.core.getModel();
        let parameters = model.getParameters();
        return parameters.getAccessToken();
    }
    handleSessionTimeOut(responseData) {
        let responseCode = responseData.getResponseCode();
        switch (responseCode) {
            case ResultCode.INVALID_TOKEN:
            case ResultCode.USER_NOT_AUTHENTICATED: {
                this.core.dispatchEvent(SessionTimeOutEvent.TIME_OUT);
                break;
            }
        }
    }
    handleRequestComplete() {
        this.handleResponse(this.request.getJSON());
    }
    handleRequestError() {
        this.handleResponse(this.request.getJSON());
    }
    getDataClass() {
        return null;
    }
    toJSON(data) {
        return JSON.stringify(data);
    }
    parseJSON(value) {
        return JSON.parse(value);
    }
    getMethod() {
        return RequestConstants.POST;
    }
    getTokenMethod() {
        return RequestConstants.BODY;
    }
    getResponseType() {
        return RequestConstants.TEXT;
    }
    getContentType() {
        return RequestConstants.APPLICATION_JSON;
    }
    getAsync() {
        return true;
    }
    tokenize() {
        return true;
    }
    getPrimaryNode() {
        return this.core.getModel().getParameters().getPrimaryNode();
    }
}
//# sourceMappingURL=WebRequest.js.map